import { IconButton } from "@mui/material";
import Text from "./Text";
import DirectMail from "./DirectMail";
import Numeration from "./Numeration";
import QRBarcode from "./qrbarcode";
import Images from "./Images";
import Shapes from "./Shapes";
import { useState, useEffect } from "react";
import { ArrowLeftSquare, ArrowRightSquare } from "react-bootstrap-icons";

import { Accordion } from "react-accessible-accordion";
import PropertyBar from "../propertyBar";
import { useBoardContext } from "@rastreabilidadebrasil/tageditor";

function ToolsBar() {
  const [hidden, setHidden] = useState<boolean>(false);
  const { board } = useBoardContext();

  const hasPropertyBar = board?.activeObjects && board.activeObjects.length > 0;

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Delete" || event.key === "Backspace") {
      const elementoAtivo = document.activeElement;
      if (
        elementoAtivo &&
        (elementoAtivo.tagName === "INPUT" ||
          elementoAtivo.tagName === "TEXTAREA" ||
          elementoAtivo.hasAttribute("contenteditable"))
      ) {
        return;
      }

      if (board?.activeObjects && board.activeObjects.length > 0) {
        if (event.key === "Backspace") {
          event.preventDefault();
        }

        board.remove(...board.activeObjects);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [board]);

  return (
    <div
      className={`toolbar-container 
        ${hidden ? "accordion-hidden" : "accordion-visible"} 
        ${hasPropertyBar ? "has-properties" : "no-properties"}`}
    >
      <div className="toolbar-accordion-container">
        {!hidden && (
          <Accordion allowZeroExpanded={true} preExpanded={["shapes"]}>
            <Shapes />
            <Text />
            <Images />
            <DirectMail />
            <Numeration />
            <QRBarcode />
          </Accordion>
        )}

        {hasPropertyBar && (
          <div className="property-sidebar-wrapper">
            <PropertyBar />
          </div>
        )}
      </div>

      <IconButton className="botao-recolher-sidebar" onClick={() => setHidden(!hidden)}>
        {hidden ? <ArrowRightSquare size={22} /> : <ArrowLeftSquare size={22} />}
      </IconButton>
    </div>
  );
}

export default ToolsBar;
